import { Unstable_Grid2 as Grid } from '@mui/material';

import { SurveyQuestionResponseStatistics } from '@occc/graphql';
import { BarChart, BorderedSection, PieChart, Typography } from '@occc/ui-design-system';

import { SurveyStatisticsBarChartItem, SurveyStatisticsPieChartItem } from './types';
import { buildTooltipProps } from './utils/buildTooltipProps';
import { buildSelectedRangeTooltipProps } from './utils/buildSelectedRangeTooltipProps';

export const AllAnswersChartSection = ({
  type,
  items,
}: SurveyStatisticsPieChartItem | SurveyStatisticsBarChartItem) => {
  return (
    <>
      {type === 'pie' && (
        <Grid sm={6} xs={12}>
          <BorderedSection height={400} p={2} direction='column'>
            <Typography alignSelf='flex-start' paddingBottom={1}>
              Responses
            </Typography>
            <PieChart items={items} />
          </BorderedSection>
        </Grid>
      )}

      {type === 'bar' && (
        <Grid sm={6} xs={12}>
          <BorderedSection height={400} p={2} direction='column'>
            <Typography alignSelf='flex-start' paddingBottom={1}>
              Responses
            </Typography>
            <BarChart<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>
              items={items}
              buildSelectedRangeTooltipProps={buildSelectedRangeTooltipProps}
              buildTooltipProps={buildTooltipProps}
            />
          </BorderedSection>
        </Grid>
      )}
    </>
  );
};
